import { tracking } from '@iwoca/frontend-tracking-library';
import { Link } from '@iwoca/orion';
import { getCurrentPathname } from '@iwRouter/LocationHelper';

import DocumentRequirement from '../DocumentRequirement';
import { TGetProductOffersResponseData } from '../TradingHistory';

type TProps = {
    isOptional: boolean;
    isSubmitted: boolean;
    status?: TGetProductOffersResponseData['products'][number]['data_requirements'][number]['status'];
};
const AgedDebtorReport = ({ isOptional, status }: TProps) => {
    return (
        <DocumentRequirement
            title="Aged debtor report"
            documentType="aged debtor report"
            isOptional={isOptional}
            status={status}
        >
            <p>
                A breakdown of outstanding payments due from your customers,
                grouped by the number of days outstanding (30, 60, 90+ days).
                Particularly useful if you use invoice financing.{' '}
                <Link
                    href="https://gocardless.com/guides/posts/aged-debtors-report/"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() =>
                        tracking.ampli.externalLinkClicked({
                            category: 'Optional document: Age debtor report',
                            'CTA destination': 'Age debtor report guide',
                            'CTA URL':
                                'https://gocardless.com/guides/posts/aged-debtors-report/',
                            'CTA text': 'Learn more',
                            'Page name': 'Application pending view',
                            URL: getCurrentPathname()
                        })
                    }
                >
                    Learn more
                </Link>
            </p>
        </DocumentRequirement>
    );
};

// eslint-disable-next-line import/no-default-export
export default AgedDebtorReport;
